var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.periodicity)?_c('span',[(!!_vm.upperCase)?[_vm._v(_vm._s(_vm.periodicity.value.toUpperCase()))]:[_vm._v(_vm._s(_vm.periodicity.value))]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }